<template>
    <div class="outer-frame  input-frame">
        <input :type="inputType()"
               class="inner"
               v-model="passwordComputed"
               spellcheck="false"/>
        <div class="show-pw-button eye icon"
             @mousedown="updateShowPassword(true)"
             @mouseleave="updateShowPassword(false)"
             @mouseup="updateShowPassword(false)"
             @touchstart="updateShowPassword(true)"
             @touchend="updateShowPassword(false)"
             @touchleave="updateShowPassword(false)"
             @touchcancel="updateShowPassword(false)"></div>
    </div>
</template>

<script lang="ts">
import {computed, defineComponent, ref, toRefs, watch} from "vue";

export default defineComponent({
    name: "PasswordInput",
    props: {
        password: String,
    },
    emits:["update:password"],
    setup(props, { emit }) {

        const showPassword = ref<boolean>(false)
        const { password } = toRefs(props)

        const passwordComputed = computed({
            get: () => password.value,
            set: val => {
                emit("update:password", val)
            }
        })

        const updateShowPassword = (show: boolean) => {
            showPassword.value = show
        }

        const inputType = (): string => {
            return showPassword.value ? "text" : "password"
        }

        return {
            showPassword,
            updateShowPassword,
            inputType,
            passwordComputed,
        }
    }
})
</script>

<style scoped lang="scss">
.outer-frame {

    position: relative;
    width: 100%;
    height: 30px;

    .inner {
        position: absolute;
        width: calc(100% - 35px);
        height: 100%;
        left: 5px;
        top: 0;
    }

    input {
        border: none;
        outline: none;
        text-indent: 10px;
        //user-select: none;
    }

    .show-pw-button {
        position: absolute;
        width: 28px;
        height: 28px;
        top: 1px;
        right: 5px;

        &:hover {
            opacity: 0.7;
        }

        &:active {
            opacity: 0.5;
        }
    }

}

.eye.icon {
    color: #555;
    position: absolute;
    margin-left: 3px;
    margin-top: 3px;
    width: 20px;
    height: 20px;
    border-radius: 70% 15%;
    border: solid 1px currentColor;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}

.eye.icon:before {
    content: '';
    position: absolute;
    left: 2px;
    top: 2px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    border: solid 1px currentColor;
}


</style>